<bn-care-plan-item-card>
  <div carePlanCardMain>
    <h4 class="bn-outcome-card__heading">
      <button
        type="button"
        class="bn-outcome-card__title"
        [disabled]="disabled()"
        (click)="openOutcome.emit(outcome())"
      >
        {{ title() }}
      </button>
    </h4>
    @if (outcome().description && outcome().description !== title()) {
      <p class="bn-outcome-card__description">{{ outcome().description }}</p>
    }
    <div class="bn-outcome-card__meta">
      @if (title() !== typeLabel()) {
        <div class="bn-outcome-card__type">{{ typeLabel() }}</div>
      }
      <div class="bn-outcome-card__recorded">
        Recorded {{ outcome().recordedAt | date: 'mediumDate' }} by
        {{ outcome().recordedBy.displayName || 'System' }}
      </div>
    </div>
    <span class="bn-outcome-card__chip">No case</span>
    @if (outcome().invalidated) {
      <span class="bn-outcome-card__removed">Removed</span>
    }
  </div>
  <div carePlanCardActions class="bn-outcome-card__actions">
    <span class="bn-outcome-card__ati"
      >ATI:
      {{
        outcome().atiValue === null
          ? 'N/A'
          : (outcome().atiValue | currency: 'USD' : 'symbol' : '1.0-2')
      }}</span
    >
    <button
      type="button"
      class="bn-outcome-card__open"
      [disabled]="disabled()"
      [attr.aria-label]="
        (editable() ? 'View/Edit outcome: ' : 'View outcome: ') + title()
      "
      (click)="openOutcome.emit(outcome())"
    >
      {{ editable() ? 'View/Edit' : 'View' }}
    </button>
  </div>
</bn-care-plan-item-card>
